import { render, staticRenderFns } from "./PhotoUploadContainer.vue?vue&type=template&id=96597de2"
import script from "./PhotoUploadContainer.vue?vue&type=script&lang=js"
export * from "./PhotoUploadContainer.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploadContainer.vue?vue&type=style&index=0&id=96597de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports